import { useMutation } from '@tanstack/react-query';

import { clearOfferMetaCache } from '~/services/PromoService';

export function useClearOfferMetaCache() {
  return useMutation({ mutationFn: clearOfferMetaCache });
}
